export default __webpack_public_path__ + "static/media/cwu15.4063c397.jpeg";